import React from 'react';
import { Link } from 'react-router-dom';
import { Eye } from 'lucide-react';

type ReportActionLinkProps = {
  reportId: string;
  stato: string;
  toVisualizza: (name: string) => string;
  reportName: string;
};

const ReportActionLink: React.FC<ReportActionLinkProps> = ({
  reportId,
  reportName,
  toVisualizza,
  stato,
}) => {
  const isDisabled = stato === 'empty';
  const decodedName = decodeURIComponent(reportName || '');

  return (
    <Link
      to={isDisabled ? '#' : toVisualizza(decodedName)}
      state={isDisabled ? undefined : { id: reportId }}
      onClick={(e) => { if (isDisabled) e.preventDefault(); }}
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition-colors
        ${isDisabled
          ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
          : 'bg-[#1B365D] text-white hover:bg-[#142a4a]'}`}
    >
      Visualizza
      <Eye className="w-3 h-3" />
    </Link>
  );
};

export default ReportActionLink;
